(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-coupon/assets/javascripts/rotate-phone.js') >= 0) return;  svs.modules.push('/components/tipsen/route-coupon/assets/javascripts/rotate-phone.js');
"use strict";


const clx = svs.components.lbUtils.clx;
const PhoneModel = _ref => {
  let children = _ref.children;
  return React.createElement("div", {
    className: "phone_model"
  }, children, React.createElement("div", {
    className: "phone_model__button phone_model__button__volume__up"
  }), React.createElement("div", {
    className: "phone_model__button phone_model__button__volume__down"
  }), React.createElement("div", {
    className: "phone_model__button phone_model__button__power"
  }), React.createElement("div", {
    className: "phone_model__camera"
  }));
};
const RotateArrow = () => React.createElement("svg", {
  className: "bi bi-arrow-90deg-right",
  fill: "currentColor",
  height: "65",
  style: {
    transform: 'scale(-1,1)'
  },
  viewBox: "0 0 16 16",
  width: "65",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("path", {
  d: "M14.854 4.854a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 4H3.5A2.5 2.5 0 0 0 1 6.5v8a.5.5 0 0 0 1 0v-8A1.5 1.5 0 0 1 3.5 5h9.793l-3.147 3.146a.5.5 0 0 0 .708.708z",
  fillRule: "evenodd"
}));
const RotatePhone = _ref2 => {
  let className = _ref2.className;
  return React.createElement("div", {
    className: clx('rotate_phone_instructions', className)
  }, React.createElement(PhoneModel, null, React.createElement(RotateArrow, null)), React.createElement("div", {
    className: "rotate_phone_instructions__text"
  }, "Rotera din enhet f\xF6r att se kupongen"));
};
setGlobal('svs.components.tipsen.routeCoupon.RotatePhone', RotatePhone);

 })(window);